import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import Image from '../Image';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-inner">
                <div className="footer-top">

                    <div className="footer-company">
                        <div className="mt-header-logo">
                            <Link to="/">
                                <Image url="/images/logo5.png"/>
                            </Link>
                        </div>

                        <p className="footer-company-description">
                            20년 이상의 경험과 전문성을 바탕으로<br />
                            고객의 소중한 행사를 함께하는 엠티미디어입니다.
                        </p>
                    </div>

                    <div className="footer-contact">
                        <div className="footer-info-block">
                            <h3>상담 전화</h3>

                            <a
                                href="tel:01090453707"
                                className="footer-phone"
                            >
                                010-9045-3707
                            </a>

                            <p className="footer-contact-time">
                                전화 · 문자 상담
                            </p>
                        </div>

                        <div className="footer-info-block footer-email">
                            <h3>이메일</h3>

                            <a
                                href="mailto:mtmedia91@gmail.com"
                                className="footer-email-link"
                            >
                                mtmedia91@gmail.com
                            </a>

                            <p>
                                이메일 문의
                            </p>
                        </div>
                    </div>

                    <div className="footer-business-info">
                        <h3>회사 정보</h3>

                        <ul>
                            <li>
                                <span>상호명</span>
                                <p>엠티미디어</p>
                            </li>

                            <li>
                                <span>대표</span>
                                <p>이경현</p>
                            </li>

                            <li>
                                <span>사업자등록번호</span>
                                <p>204-12-92497</p>
                            </li>

                            <li>
                                <span>주소</span>
                                <p>서울특별시 성북구 화랑로32길 35 1층</p>
                            </li>

                            <li>
                                <span>개인정보 관리책임자</span>
                                <p>이경현</p>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-links">
                        <h3>바로가기</h3>

                        <Link to="/inquiry">
                            견적문의
                            <span>→</span>
                        </Link>

                        <Link to="/portfolio">
                            시공사례
                            <span>→</span>
                        </Link>

                        <Link to="/rentalService">
                            렌탈안내
                            <span>→</span>
                        </Link>
                    </div>

                </div>

                <div className="footer-bottom">
                    <div className="footer-policy">
                        <Link to="/privacy">
                            개인정보처리방침
                        </Link>

                        <span></span>

                        <Link to="/rentalService">
                            이용안내
                        </Link>
                    </div>

                    <p className="footer-copyright">
                        © 2026 MTMEDIA. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;